import React from 'react';
import { connect } from 'react-redux';

//import Panel from '@scene/objects/panel';
import ScrewGroup from '@scene/objects/screw/screw-group';

import SpacingSquareBase from './SpacingSquareBase';
import SpacingCircleBase from './SpacingCircleBase';
import SpacingTriangleBase from './SpacingTriangleBase';
import Application from '../../../../Application';
import Input from '@components/Input';
import { setDy } from '@reducers/options/panel/actions';
import { setScrewOptions } from '@reducers/options/screw/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import * as THREE from 'three';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../texts/tooltips';
import { setCustomCoordinates } from '@reducers/selectors/dimension/actions';

function Spacing(props) {
  return (
    <div>
      {(props.screw.formation === ScrewGroup.formation.NOT_SET ||
        props.screw.formation === ScrewGroup.formation.FILLED_SQUARE ||
        props.screw.formation === ScrewGroup.formation.BEND || 
        (props.screw.formation === ScrewGroup.formation.TRIANGLE && props.type === Application.types.SAFETY_BARRIER)) && 
          <SpacingSquareBase options={props.screw} onUpdate={props.setScrew} setCustomCoordinates={props.setCustomCoordinates}/>}

      {props.screw.formation === ScrewGroup.formation.CIRCLE && (
        <SpacingCircleBase options={props.screw} onUpdate={props.setScrew} setCustomCoordinates={props.setCustomCoordinates}/>
      )}

      {props.type !== Application.types.SAFETY_BARRIER && props.screw.formation === ScrewGroup.formation.TRIANGLE && (
        <SpacingTriangleBase options={props.screw} onUpdate={props.setScrew} setCustomCoordinates={props.setCustomCoordinates} />
      )}

      {props.type === Application.types.SAFETY_BARRIER && (
        <Tooltip content={APP_TOOLTIPS.TOOLTIP_SPACING_DISTANCE.Content}>
        <Input
          prefix="Dy ="
          postfix={unitLabel(props.unit)}
          className="base-plate__input_block"
          id="dy"
          type="number"
          minValue={0}
          disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
          value={unitTransform(props.panel.dy.value || 0)
            .from(defaultUnits.DISTANCE)
            .to(props.unit)}
          onUpdate={value => {
            props.setDy(value, props.unit);
          }}
        />
        </Tooltip>
      )}
    </div>
  );
}

const mapState = state => {
  var coordinatesList = [];
  if (state.options.screw.coordinatesList)
    coordinatesList = state.options.screw.coordinatesList.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z * -1));
  return {
    panel: state.options.panel,
    screw: { ...state.options.screw, coordinatesList: coordinatesList},
    type: state.main.appType,
    unit: state.main.units.distance,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
  };
};
const mapDispatch = dispatch => ({
  setDy: (value, unit) => dispatch(setDy({
    isCustom: true,
    value: unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE)
  })),
  setScrew: value => { 
    if (value.custom && value.custom.positions)
      value.custom.positions = value.custom.positions.map(pos => new THREE.Vector3(pos.x, pos.y * -1, pos.z * -1));
    dispatch(setScrewOptions(value));
  },
  setCustomCoordinates: value => dispatch(setCustomCoordinates(value))
});

export default connect(
  mapState,
  mapDispatch
)(Spacing);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Spacing/index.js